import { fromJS } from 'immutable';

import { requestTypes } from '@src/utils/duckHelpers';

const mobileMenuTypes = requestTypes('MOBILE_MENU');

const initialState = fromJS({
    loaded: 'loading',
    menu: [],
});

const mobileMenuReducer = (state = initialState, action) => {
    switch (action.type) {
    case mobileMenuTypes.MOBILE_MENU_REQUEST:
        return state.merge({
            loaded: 'loading',
        });
    case mobileMenuTypes.MOBILE_MENU_SET:
        return state.merge({
            loaded: 'complete',
            menu: action.payload.menus || [],
        });
    default:
        return state;
    }
};

export {
    mobileMenuReducer as default,
    mobileMenuTypes,
};
